import { defineRoutes } from './types';

type StringOrNumber = string | number;

export type PartnerAdapterPathConfig = {
  adapterPushResultDetail: { ioResultId: StringOrNumber };
};

/** Adapter I/O path helpers — mounted in admin only; partner deep-links via getExternalAppUrl. */
export const partnerAdapterRoutes = defineRoutes<PartnerAdapterPathConfig>()({
  /** Unified adapter I/O results list (entity subjects, push + pull chains). */
  adapterPushResults: {
    getPath: () => '/adapters/io-results',
    getBasePath: () => '/adapters/io-results'
  },
  /** @deprecated Use adapterPushResults; FE redirects this path. */
  // oxlint-disable-next-line typescript/no-deprecated -- legacy URL kept as a redirect source
  adapterPullResults: {
    getPath: () => '/adapters/io-results/pull',
    getBasePath: () => '/adapters/io-results/pull'
  },
  /** Adapter background job runs + manual SyncJob triggers. */
  adapterBackgroundJobs: {
    getPath: () => '/adapters/io-results/jobs',
    getBasePath: () => '/adapters/io-results/jobs'
  },
  adapterRecallExclusions: {
    getPath: () => '/adapters/recall-exclusions',
    getBasePath: () => '/adapters/recall-exclusions'
  },
  /** Detail for a preferred step; loads full subject chain timeline. */
  adapterPushResultDetail: {
    getPath: ({ ioResultId }) => `/adapters/io-results/${ioResultId}`,
    getBasePath: () => '/adapters/io-results/:ioResultId'
  }
});
